module.exports = __webpack_public_path__ + "assets/chevin-light.6064ee4f111d20449be05dec7485caaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-light.svg
// module id = 134
// module chunks = 0